/** Rarity numbers the card-generate audit records (Rare or better, plus rejected Common). */
export function rarityName(rarity: number): string {
  switch (rarity) {
    case 0:
      return 'Common';
    case 1:
      return 'Rare';
    case 2:
      return 'Epic';
    case 3:
      return 'Legendary';
    default:
      return `Rarity ${rarity}`;
  }
}

/** The build the client reported: its number, else its version, else "not sent". */
export function buildLabel(r: { buildNumber: number | null; buildVersion: string | null }): string {
  if (r.buildNumber !== null && r.buildNumber !== undefined) return String(r.buildNumber);
  return r.buildVersion || 'not sent';
}
